import { render, staticRenderFns } from "./requestor-info.vue?vue&type=template&id=59055cbf&"
import script from "./requestor-info.vue?vue&type=script&lang=js&"
export * from "./requestor-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports